/** Opciones del filtro de alertas (sidebar desktop y Offcanvas móvil). */
export const ALERT_CATEGORY_FILTER_OPTIONS = [
  { value: "mantenimiento", label: "Mantenimiento" },
  { value: "capacitacion_vial", label: "Trabajo anual" },
  { value: "capacitacion_plan_anual", label: "Capacitacion anual" },
  { value: "documentos_por_vencer", label: "Documentos por vencer" },
];
